module.exports = __webpack_public_path__ + "files/5f3f8275367e455eff9144bfb163686b.png";